module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "belt__pagination--nav"
  }, [_c('a', {
    staticClass: "belt__pagination--prev",
    attrs: {
      "href": "",
      "disabled": _vm.isFirstPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.prev_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "belt__pagination--input-container"
  }, [_c('p', [_c('input', {
    staticClass: "belt__pagination--input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.totalPagesNum,
      "placeholder": "Page number",
      "disabled": _vm.loading.state
    },
    domProps: {
      "value": _vm.getCurrentPage
    },
    on: {
      "change": function($event) {
        _vm.updateCurrentPage($event)
      }
    }
  })]), _vm._v(" "), (_vm.appIsRunning) ? _c('p', {
    staticClass: "belt__pagination--max"
  }, [_c('span', {
    staticClass: "belt__pagination--max-from"
  }, [_vm._v(_vm._s(_vm.$lang.pagination.from_pages))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "title": _vm.totalPagesNum
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActivePage(_vm.totalPagesNum)
      }
    }
  }, [_vm._v(_vm._s(_vm.totalPagesNum))])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "belt__pagination--next",
    attrs: {
      "href": "",
      "disabled": _vm.isLastPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.next_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704e50d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/PaginationWithInput.vue
// module id = 344
// module chunks = 1